import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { PopupTriggerProps } from '@atlassian/jira-development-board-common/src/types.tsx';
import parameters, {
	type BranchDetailsPopupViewBranchDetailsPopupViewQuery,
} from '@atlassian/jira-relay/src/__generated__/BranchDetailsPopupViewBranchDetailsPopupViewQuery.graphql';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const branchDetailsEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			branchDetailsForIssue: BranchDetailsPopupViewBranchDetailsPopupViewQuery;
		},
		{},
		PopupTriggerProps,
		{}
	>,
	{
		issueId: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-branch-details-popup-new" */ './src/ui/branch-details-popup-view/BranchDetailsPopupView.tsx'
			),
	),
	getPreloadProps: ({ issueId }: { issueId: string }) => ({
		queries: {
			branchDetailsForIssue: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					issueId,
				},
			},
		},
	}),
});
